import { Directive, ElementRef, Input, OnChanges } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";

@Directive({
  standalone: false,
  selector: '[appInputFieldLabcorpClass]'
})
export class InputFieldLabcorpClassDirective implements OnChanges {

  @Input()
  formControlName: string;

  constructor(private el: ElementRef, private formGroup: FormGroupDirective) { }

 ngOnInit() {

      this.el.nativeElement.classList.add('form-control');

  }

  ngOnChanges() {
    const control = this.formGroup.form.controls[this.formControlName];

    if (control.dirty || control.touched) {
      this.el.nativeElement.classList.removeAll();
      if (control.valid) {
        this.el.nativeElement.classList.add('form-control is-valid');
      } else {
        this.el.nativeElement.classList.add('form-control is-invalid');
      }
    } else {
      this.el.nativeElement.classList.add('form-control');
    }
  }
}
